module.exports = __webpack_public_path__ + "static/media/Piercing-nipple.8729a31a.png";